import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { usersService } from '@/services/http/usersService'

type Props = {
  startDate?: Date
  endDate?: Date
  challenges?: string[]
}

export const useDashboardTopTenUsers = ({
  startDate,
  endDate,
  challenges,
}: Props) => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: [
      'dashboardTopTenUsers',
      {
        startDate,
        endDate,
        challenges,
      },
    ],
    queryFn: () =>
      usersService.getDashboardTopTenUsers({
        startDate,
        endDate,
        challenges,
      }),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar dados do top 10 usuários do dashboard',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    const { topTenUsers } = data
    return {
      topTenUsers,
      isLoading,
      refetchDashboardTopTenUsers: refetch,
    }
  }

  return {
    topTenUsers: [],
    isLoading,
    refetchDashboardTopTenUsers: refetch,
  }
}
